import { useState, useEffect } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";

import { selectFacility } from "../app/actions/facilities";
import { Outlet } from "react-router-dom";
import { getFacilities } from "../app/actions/facilities";

const SelectFacilityWidget = () => {
  const { selectedFacility, myfacilities } = useSelector(
    (state) => state.facility
  );

  useEffect(() => {
    if (!myfacilities.length) {
      dispatch(getFacilities());
    }
  }, [myfacilities]);

  const facilities = myfacilities
    ? myfacilities.map((facilityData) => {
        return { label: facilityData.name, value: facilityData.id };
      })
    : [];

  const dispatch = useDispatch();

  const onSelect = (selectedData) => {
    console.log("onSelect");
    dispatch(selectFacility(selectedData));
  };

  return (
    <>
      <Select
        options={facilities}
        onChange={onSelect}
        value={selectedFacility}
        isClearable
      />
      {selectedFacility && (
        <>
          <div className="selected-item">
            <label>Selected Facility:</label> {selectedFacility.label}
          </div>
        </>
      )}

      <div>
        <Outlet />
      </div>
    </>
  );
};

export default SelectFacilityWidget;
